module.exports = __webpack_public_path__ + "static/media/kuppi_boost_trial.a3c4577f.png";